export default "/static/media/ipBlocked.98d1bcda.webm";